import { BLANKS_GROUP, TRANSFERS_GROUP, PRINT_GROUP } from "../app-registry/contants";

const businessLineToUrlGroup = businessLine => {
  if (BLANKS_GROUP.includes(businessLine)) return "blanks";
  if (TRANSFERS_GROUP.includes(businessLine)) return "transfers";
  if (PRINT_GROUP.includes(businessLine)) return "print";
  return null;
};

export default businessLineToUrlGroup;
